import { render, staticRenderFns } from "./invoking.vue?vue&type=template&id=67efd56f"
import script from "./invoking.vue?vue&type=script&lang=js"
export * from "./invoking.vue?vue&type=script&lang=js"
import style0 from "./invoking.vue?vue&type=style&index=0&id=67efd56f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports